import {
  MissionControlStaffingRequestCountersQueryCgResponse,
  MissionControlStaffingRequestCountersQueryVariables,
} from '@common/graphql';
import { gql, TypedDocumentNode } from '@common/hooks';

export const MISSION_CONTROL_STAFFING_REQUEST_COUNTERS_QUERY: TypedDocumentNode<
  MissionControlStaffingRequestCountersQueryCgResponse,
  MissionControlStaffingRequestCountersQueryVariables
> = gql`
  query MissionControlStaffingRequestCounters {
    missionControlStaffingRequestCounters {
      approvalQueue
      upcomingJobs
      candidatesInScreening
      reviewsPending
      offersPending
    }
  }
`;
